export default "__VITE_ASSET__C6QxaZA6__"